import { createEntityAdapter } from '@reduxjs/toolkit';
import { schema } from 'normalizr';
import { RootState } from 'redux/store';
import { CopyDestinationLayoutListResponse } from 'types/entity';

export const layoutCopyDestinationSchema = new schema.Entity(
  'layoutCopyDestination',
  {},
  {
    idAttribute: (value: CopyDestinationLayoutListResponse) => value.source_layout.layout_id || '',
  },
);

export const layoutCopyReadAdapter = createEntityAdapter<CopyDestinationLayoutListResponse>({
  selectId: (model) => model.source_layout.layout_id || '',
});

export const {
  selectById,
} = layoutCopyReadAdapter.getSelectors<RootState>((state) => state.layoutCopyRead);
